import React, {useState, useEffect} from 'react';
import post from '../utils/post.js';
import AppHeader from '../components/AppHeader.js';
import Search from '../components/Search.js';
import NoteNew from '../components/NoteNew.js';
import NoteEdit from '../components/NoteEdit.js';
import clipboard from '../utils/clipboard.js';

const renderNoteNumber = (sortorder) => `${sortorder}.`;

export default function Note({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [dataDetail, setDataDetail] = useState({});
	const [showNew, setShowNew] = useState(false);
	const [showEdit, setShowEdit] = useState(false);
	const [offset, setOffset] = useState(0);
	const [searchValue, setSearchValue] = useState('');
	const [loadedCnt, setLoadedCnt] = useState(0);

	useEffect(() => {
		getData('', offset);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const loadNext = () => {
		setOffset((prevOffset) => {
			let newOffset = prevOffset + usrInfo.LIST_ROWS;
			getData(searchValue, prevOffset + usrInfo.LIST_ROWS);
			return newOffset;
		});
	};

	const onChangeSearch = (value) => {
		setSearchValue(value);
		setOffset(0);
		getData(value, 0);
	};

	const getData = (search, offset) => {
		setLoading(true);

		post('getListNote', {search: search, offset: offset})
			.then((res) => {
				if (offset === 0) {
					setData(res.data);
				} else {
					setData((prevRows) => {
						const updatedRows = [...prevRows, ...res.data];
						return updatedRows;
					});
				}

				setLoadedCnt(res.data.length);

				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const handleNew = () => {
		setShowNew(true);
	};

	const closeNew = () => {
		setShowNew(false);
	};

	const updateNoteRowNew = (row) => {
		setData([row, ...data]);
	};

	const handleEdit = (rec) => {
		setShowEdit(true);
		setDataDetail(rec);
	};

	const closeEdit = () => {
		setShowEdit(false);
	};

	const updateNoteRowEdit = (row) => {
		const newData = data.map((item) => {
			if (item.ID === row.ID) {
				item.SORTORDER = row.SORTORDER;
				item.NAME = row.NAME;
				item.NOTE = row.NOTE;
				item.NOTES = row.NOTES;
			}

			return item;
		});

		setData(newData);
	};

	const updateNoteRowDelete = (row) => {
		const newData = data.filter((item) => {
			return item.ID !== row;
		});

		setData(newData);
	};

	const list = data.map((item, index) => {
		return (
			<div className="note-page__card" key={index}>
				<div className="note-page__card-head">
					<div className="note-page__card-title-wrap">
						<div className="note-page__card-number">{renderNoteNumber(item.SORTORDER)}</div>
						<div className="note-page__card-title">
							<b>
								<span dangerouslySetInnerHTML={{__html: item.NAME}} style={{wordWrap: 'break-word'}}></span>
							</b>
						</div>
					</div>
					<div className="note-page__card-actions">
						<button type="button" className="note-page__icon-button" onClick={() => clipboard(item.NOTE)}>
							<img className="icon1 copy" alt="" />
						</button>
						<button type="button" className="note-page__icon-button" onClick={() => handleEdit(item)}>
							<img className="icon1 edit" alt="" />
						</button>
					</div>
				</div>
				<div className="note-page__card-body">
					<span dangerouslySetInnerHTML={{__html: item.NOTES}} style={{wordWrap: 'break-word'}}></span>
				</div>
			</div>
		);
	});

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />
				<Search showNew handleNew={handleNew} showSearch searchValue={searchValue} onChangeSearch={(e) => onChangeSearch(e)} />
				<NoteNew showNew={showNew} closeNew={closeNew} updateNoteRowNew={updateNoteRowNew} />
				<NoteEdit showEdit={showEdit} closeEdit={closeEdit} updateNoteRowEdit={updateNoteRowEdit} updateNoteRowDelete={updateNoteRowDelete} data={dataDetail} />

				<div className={`page note-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<div className="note-page__shell">
						<section className="note-page__section">
							<div className="note-page__list">
								{list.length > 0 ? list : <div className="note-page__empty">Žádné poznámky nebyly nalezeny.</div>}
							</div>

							<div className="note-page__load-more">
								{parseInt(loadedCnt) === parseInt(usrInfo.LIST_ROWS) ? (
									<button className="button small loadNext note-page__button" onClick={() => loadNext()}>
										Načíst další
									</button>
								) : (
									<span className="fnt_12 loadNext note-page__load-all">Byly načteny všechny záznamy</span>
								)}
							</div>
						</section>
					</div>
				</div>
			</div>
		</>
	);
}
